import { EDITOR_MODE } from "@pathwright/blocks-engine"
import FlashcardsContainer from "./FlashcardsContainer"

const FlashcardsEdit = (props) => {
  return <FlashcardsContainer {...props} mode={EDITOR_MODE.EDIT} />
}

export default FlashcardsEdit
